module.exports = __webpack_public_path__ + "static/media/internet_banking_icon.9572ef15.svg";